import type { PropsWithChildren } from "react";

import { TextAnchor } from "@similarweb/pro-logic-components";

import { CellDefaultTooltip } from "app/pages/sales-intelligence/common-components/table-cells";

type Props = PropsWithChildren<{ overviewLink: string; tooltipContent: string }>;

const AppCellContent = ({ children, overviewLink, tooltipContent }: Props) => {
    return (
        <CellDefaultTooltip content={tooltipContent}>
            <TextAnchor
                href={overviewLink}
                target="_blank"
            >
                {children}
            </TextAnchor>
        </CellDefaultTooltip>
    );
};

export default AppCellContent;
